// Learners' plays by day (GET /overview by_day): one stacked bar a day - succeeded, didn't succeed, left before the end.
import React, { useState } from "react";

const SERIES = [
  { key: "won", label: "Succeeded", cls: "db-s-won" },
  { key: "not_won", label: "Didn't succeed", cls: "db-s-lost" },
  { key: "left", label: "Left early", cls: "db-s-left" },
];
const W = 600, H = 170, LEFT = 30, BOTTOM = 22, TOP = 8;

const niceMax = (n) => {
  if (n <= 4) return 4;
  const step = 10 ** Math.floor(Math.log10(n));
  return Math.ceil(n / step) * step;
};
const dayLabel = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export default function ProgressChart({ days }) {
  const [hover, setHover] = useState(null);
  const totals = days.map((d) => d.won + d.not_won + d.left);
  const max = niceMax(Math.max(0, ...totals));
  const plotH = H - TOP - BOTTOM;
  const slot = (W - LEFT) / days.length;
  const barW = Math.max(4, slot * 0.62);
  const y = (v) => TOP + plotH - (v / max) * plotH;
  const ticks = [0, max / 4, max / 2, (3 * max) / 4, max];
  const shown = hover === null ? null : days[hover];

  return (
    <div className="db-chart">
      <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={`Learner plays per day for the last ${days.length} days`}
        onMouseLeave={() => setHover(null)}>
        {ticks.map((t) => (
          <g key={t}>
            <line x1={LEFT} x2={W} y1={y(t)} y2={y(t)} className="db-grid" />
            <text x={LEFT - 6} y={y(t) + 4} textAnchor="end" className="db-axis">{Number.isInteger(t) ? t : ""}</text>
          </g>
        ))}
        {days.map((d, i) => {
          const x = LEFT + i * slot + (slot - barW) / 2;
          let base = 0;
          return (
            <g key={d.day} onMouseEnter={() => setHover(i)}>
              <rect x={LEFT + i * slot} y={TOP} width={slot} height={plotH} fill="transparent" />
              {SERIES.map((s) => {
                const v = d[s.key];
                if (!v) return null;
                const rect = <rect key={s.key} x={x} width={barW} y={y(base + v)} height={y(base) - y(base + v)} rx={1.5} className={s.cls} />;
                base += v;
                return rect;
              })}
              {i % 7 === 0 && <text x={x + barW / 2} y={H - 6} textAnchor="middle" className="db-axis">{dayLabel(d.day)}</text>}
            </g>
          );
        })}
      </svg>
      <div className="db-chart-foot">
        <div className="db-legend">
          {SERIES.map((s) => <span key={s.key}><i className={s.cls} aria-hidden="true" />{s.label}</span>)}
        </div>
        <div className="db-chart-hover" aria-live="polite">
          {shown && `${dayLabel(shown.day)}: ${shown.won} succeeded, ${shown.not_won} didn't, ${shown.left} left early`}
        </div>
      </div>
    </div>
  );
}
